import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import type { AtVirtualClinicTreatmentType } from '@bindoc-projects/virtual-clinic-domain-lib';

export const AT_TREATMENT_TYPE_CONDITION_ID = 'treatmentTypeAT';
export const AtFilterConditionTreatmentTypePluginType: FilterConditionPluginSpecification<
  AtVirtualClinicTreatmentType[],
  AtFilterConditionTreatmentTypeDto,
  AtTreatmentTypeCondition
> = {
  type: 'treatmentType',
  category: 'case',
  displayName: { de: 'Behandlungsart' },
  sortingIndex: 1,
  occurrence: 'single',
  fromObject(
    obj: AtFilterConditionTreatmentTypeDto,
  ): FilterConditionPluginImpl<AtVirtualClinicTreatmentType[]> {
    return new AtFilterConditionTreatmentTypePlugin(obj.treatmentType);
  },
  fromCondition(
    jsonObj: AtTreatmentTypeCondition,
  ): FilterConditionPluginImpl<AtVirtualClinicTreatmentType[]> {
    return new AtFilterConditionTreatmentTypePlugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<AtVirtualClinicTreatmentType[]> {
    return new AtFilterConditionTreatmentTypePlugin([]);
  },
};

export class AtFilterConditionTreatmentTypePlugin extends FilterConditionPluginImpl<
  AtVirtualClinicTreatmentType[],
  AtFilterConditionTreatmentTypeDto
> {
  static override Specification: FilterConditionPluginSpecification<
    AtVirtualClinicTreatmentType[],
    AtFilterConditionTreatmentTypeDto,
    AtTreatmentTypeCondition
  > = AtFilterConditionTreatmentTypePluginType;

  constructor(protected treatmentType: AtVirtualClinicTreatmentType[]) {
    super(AtFilterConditionTreatmentTypePluginType.type);
  }

  clone(): AtFilterConditionTreatmentTypePlugin {
    return new AtFilterConditionTreatmentTypePlugin([...this.treatmentType]);
  }

  override equals(other: AtFilterConditionTreatmentTypePlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(this.treatmentType, other.treatmentType)
    );
  }

  override validationToText(): string {
    if (this.treatmentType.length === 0) {
      return 'Mindestens eine Behandlungsart auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new AtTreatmentTypeCondition(this.treatmentType, []);
  }

  toText(): string | null {
    return this.treatmentType.length === 1
      ? 'eine Behandlungsart'
      : `${this.treatmentType.length} Behandlungsarten`;
  }

  toJSON(): AtFilterConditionTreatmentTypeDto | null {
    return {
      type: this.type,
      treatmentType: this.treatmentType,
    };
  }

  toValue(): AtVirtualClinicTreatmentType[] {
    return this.treatmentType;
  }
}

export class AtTreatmentTypeCondition extends BdContentCondition<AtVirtualClinicTreatmentType> {
  constructor(
    includes: AtVirtualClinicTreatmentType[],
    excludes: AtVirtualClinicTreatmentType[],
  ) {
    super(AT_TREATMENT_TYPE_CONDITION_ID, includes, excludes);
  }
}

interface AtFilterConditionTreatmentTypeDto {
  type: string;
  treatmentType: AtVirtualClinicTreatmentType[];
}
